import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch } from '../../../../../utils';
import axios from 'axios';

const TABLE_HEADER = [
  {
    header: 'Service Name',
    accessor: (row) => row?.serviceData?.service_name
  }
];

export const ServiceDetailForm = ({ onClose, onAdd, doctorID, service, sponsorID }) => {
  const [inputService, setInputService] = useState('');
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [originalServiceData, setOriginalServiceData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [priceListDropdown, setPriceListDropdown] = useState([]);

  console.log(sponsorID, 'HELLLO SPOSNOR ID ');
  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    setDoctorDropdown(data);
  }, []);

  useEffect(() => {
    getDoctorDropdown();
  }, [getDoctorDropdown]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        service_name: Yup.string().required('Please select Service')
      })
    ),
    defaultValues: {
      doctor: doctorID || '',
      quantity: 1
    },
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    const serviceId = service.find(({ service_name }) => service_name === formValues.service_name)?._id || '';
    const transformedValues = {
      ...formValues,
      service_name: serviceId
    };
    console.log('HELLLO TRANSFORMED VALUES', transformedValues);
    onAdd(transformedValues);
  };

  const handleServiceSelection = (row) => {
    setValue(
      'rate',
      row?.inputValues[0]['NABH Ipd Char'] > 0
        ? row?.inputValues[0]['NABH Ipd Char']
        : row?.inputValues[0]['Ipd Charge'] || 0
    );

    setValue('service_name', row?.serviceData?.service_name);
  };

  useEffect(() => {
    if (service && Array.isArray(service) && service.length > 0) {
      setOriginalServiceData(service);
      setIsFiltered(false);
    }
  }, [service]);

  useEffect(() => {
    getServiceDropdownn(inputService);
  }, [inputService]);

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInputService(newInput);
  };

  const getServiceDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/price-list-master/list?&sponsorName=${sponsorID}`);
    setPriceListDropdown(response.data.data);
  }, [sponsorID]);

  useEffect(() => {
    getServiceDropdown();
  }, [sponsorID]);

  const getServiceDropdownn = useCallback(async () => {
    const response = await axios.get(
      `${BASE_URL}/price-list-master/list?&sponsorName=${sponsorID}&serviceName=${inputService}`
    );
    console.log(response.data.data);
    setPriceListDropdown(response.data.data);
  }, [sponsorID, inputService]);

  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Billing Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
        <MuiTextField
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root': {
              padding: '0'
            },
            '& .MuiOutlinedInput-input': {
              padding: '8px 14px'
            }
          }}
          label="Search Services"
          variant="outlined"
          value={inputService}
          onChange={handleChange}
          InputProps={{
            style: {
              fontSize: '12px',
              fontWeight: 600
            }
          }}
        />
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={6}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Table
              containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
              size="small"
              sx={{ fontSize: '32px' }}
              data={priceListDropdown || []}
              columns={TABLE_HEADER}
              onRowClick={handleServiceSelection}
            />
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
              {/* <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Operating Doctor</Typography>
                                <SelectTag
                                    formControlSX={{ flex: 0.8 }}
                                    name="doctor"
                                    placeholder="Operating Doctor"
                                    menus={doctorDropdown}
                                />
                            </Stack> */}
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Service Name</Typography>
                <TextField sx={{ flex: 0.8 }} name="service_name" placeholder="Service Name" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Quantity</Typography>
                <TextField
                  inputProps={{ style: { fontSize: '1.5rem', padding: '5px', min: '0' } }}
                  sx={{ flex: 0.8 }}
                  type="number"
                  name="quantity"
                  placeholder="Quantity"
                />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="40%">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
